import { Box, Typography } from "@mui/material"
import { useSelector } from "react-redux"
import { PracticeDeactivateButton } from "./Atom"
import { useEffect } from "react"

type Props = {
  updatePracticeStatus: any
}

const PracticeList = (props: Props) => {
  const { updatePracticeStatus } = props

  const practices = useSelector((state: any) => {
    return state.groupProfile.practiceList
  })

  useEffect(() => {}, [practices])

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        position: "relative",
        "& .MuiTabPanel-root": {
          padding: "0px",
        },
        flexGrow: 1,
        minWidth: {
          xs: "100%",
          sm: "100%",
          md: "100%",
          lg: "100%",
          xl: "100%",
        },
        maxWidth: {
          xs: 320,
          sm: "600px",
          md: "600px",
          lg: "564px",
          xl: "600px",
        },
      }}
    >
      {practices.map((practice: any, index: number) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #E0E0E0",
            padding: "10px",
          }}
        >
          <Typography marginLeft={"20px"}>{practice.name}</Typography>
          <PracticeDeactivateButton
            variant="text"
            isActive={practice.practice_status === "active"}
            onClick={() => updatePracticeStatus(practice)}
            // disabled={isActivationButtonDisabled}
          >
            {practice.practice_status === "inactive"
              ? "Reactivate"
              : "Deactivate"}
          </PracticeDeactivateButton>
        </Box>
      ))}
    </Box>
  )
}

export default PracticeList
